// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "InlineNotification-module--cds--assistive-text--5c85e";
export var cdsVisuallyHidden = "InlineNotification-module--cds--visually-hidden--afff8";
export var darkMode = "InlineNotification-module--darkMode--9dd0f";
export var hideFeedback = "InlineNotification-module--hide-feedback--6910c";
export var notification = "InlineNotification-module--notification--f18fa";
export var showFeedback = "InlineNotification-module--show-feedback--d5aaa";
export var skeleton = "InlineNotification-module--skeleton--bf87d";